import AgeLineChartList from "../../../../../../components/Charts/Ageline/AgeLineChartList";



export default function GetFitnessChart() {

const chronologicalAge = 62;

const sampleData = [
  { disease: 'Physical Status', age: 58 },
   { disease: 'Pace of Physical Decline', age: 71 },

];

  return (

      <div style={{ padding: '2rem' }}>
      <AgeLineChartList chronologicalAge={chronologicalAge} data={sampleData} />
    </div>
    
  );
};




